import React from 'react';
import { Button, Image } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const Card = (props) => {
  const isMimrylo = props.selectedProduct === 'mimrylo';

  return (
    <div className="cards">
      <div className={ `copay-card ${isMimrylo ? 'mimrylo-card' : ''}` }>
        <Image src={ isMimrylo ? '/images/mimrylo_co-pay_card_front.png' : '/images/co-pay_card_front.png' } alt={ `${isMimrylo ? 'MIMRYLO Takeda Oncology Co-Pay card front' : 'Takeda Oncology Co-Pay card front'}` } />
        <div className="card-details">
          <p className="card-bin">{props.cardBin}</p>
          <p className="card-pen">{props.cardPcn}</p>
          <p className="group-id">{props.groupId}</p>
          <p className="card-id">{props.cardId}</p>
        </div>
      </div>
      <div className="copay-card">
        { !props.front ? <Image src={ isMimrylo ? '/images/mimrylo_co-pay_card_back.png' : '/images/co-pay_card_back.png' } alt={ `${isMimrylo ? 'MIMRYLO Takeda Oncology Co-Pay card back' : 'Takeda Oncology Co-Pay card back'}` } /> : '' }
      </div>
      {
        !props.hideButton
          ? <Button
            as={ Link }
            target="_blank"
            rel="noopener noreferrer"
            to={ props.altFootnoteSymbol
              ? {
                pathname: `/print-card/${props.groupId}/${props.cardId}/${props.cardBin}/${props.cardPcn}?product=${props.selectedProduct}`,
                state: {
                  altFootnoteSymbol: true,
                },
              }
              : `/print-card/${props.groupId}/${props.cardId}/${props.cardBin}/${props.cardPcn}?product=${props.selectedProduct}` }
            className={ props.className }
          >Print Card</Button>
          : ''
      }
    </div>
  );
};

Card.propTypes = {
  tracking: PropTypes.string,
  hideButton: PropTypes.bool,
  cardId: PropTypes.string.isRequired,
  groupId: PropTypes.string.isRequired,
  front: PropTypes.bool,
  selectedProduct: PropTypes.string,
};

export default Card;
